import { ref } from 'vue'
import { defineStore } from 'pinia'

declare global {
  interface Window {
    _undoFunction: () => void
  }
}

type Anchor =
  | 'top'
  | 'bottom'
  | 'start'
  | 'end'
  | 'top start'
  | 'top end'
  | 'top center'
  | 'bottom start'
  | 'bottom end'
  | 'bottom center'

export const useSnackBarStore = defineStore('snack-bar', () => {
  const content = ref<string | unknown>('')
  const snackBar = ref(false)
  const color = ref('primary-4')
  const location = ref<Anchor | undefined>('bottom center')
  const timeout = ref(3000)

  const SHOW_SUCCESS = (message: unknown) => {
    color.value = 'brand-green'
    content.value = message
    timeout.value = 3000
    snackBar.value = true
  }
  const SHOW_WARNING = (message: unknown) => {
    color.value = 'brand-yellow'
    content.value = message
    timeout.value = 3000
    snackBar.value = true
  }
  const SHOW_ERROR = (message: unknown) => {
    color.value = 'danger'
    content.value = message
    timeout.value = 3000
    snackBar.value = true
  }
  const SHOW_UNDO = (message: unknown, undo: () => void) => {
    color.value = 'var(--sds-color-background-danger-tertiary-hover)'
    window._undoFunction = undo
    timeout.value = 10000
    const undoBtn = `<button class="undo-btn" onclick="window._undoFunction()" style="color: var(--sds-color-text-brand-yellow); text-decoration: underline;">Undo.</button>`
    content.value = `<div class="d-flex flex-row align-center justify-center ga-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M15.8592 13.3149L8.8395 1.67334C8.66209 1.37912 8.34356 1.19922 7.99997 1.19922C7.65637 1.19922 7.33784 1.37909 7.16044 1.67334L0.140811 13.3149C-0.0417515 13.6177 -0.0471578 13.9953 0.126717 14.3032C0.300592 14.611 0.626748 14.8014 0.980311 14.8014H15.0197C15.3732 14.8014 15.6994 14.611 15.8732 14.3032C16.0471 13.9953 16.0417 13.6177 15.8592 13.3149ZM8.00522 5.22616C8.40837 5.22616 8.7495 5.45359 8.7495 5.85672C8.7495 7.08681 8.60478 8.8545 8.60478 10.0846C8.60478 10.4051 8.25331 10.5394 8.00522 10.5394C7.67447 10.5394 7.39534 10.405 7.39534 10.0846C7.39534 8.8545 7.25065 7.08681 7.25065 5.85672C7.25065 5.45359 7.5814 5.22616 8.00522 5.22616ZM8.01556 12.8446C7.56075 12.8446 7.21959 12.4725 7.21959 12.0487C7.21959 11.6145 7.56072 11.2528 8.01556 11.2528C8.43937 11.2528 8.80118 11.6145 8.80118 12.0487C8.80118 12.4725 8.43937 12.8446 8.01556 12.8446Z" fill="#F7BF30"/>
</svg>  <span class="text-note">${message}</span>${undoBtn}</div>`

    snackBar.value = true
  }
  const SHOW_MESSAGE = (message: unknown) => {
    color.value = 'var(--sds-color-background-danger-tertiary-hover)'
    timeout.value = 10000
    content.value = `<div class="d-flex flex-row align-center justify-center ga-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M15.8592 13.3149L8.8395 1.67334C8.66209 1.37912 8.34356 1.19922 7.99997 1.19922C7.65637 1.19922 7.33784 1.37909 7.16044 1.67334L0.140811 13.3149C-0.0417515 13.6177 -0.0471578 13.9953 0.126717 14.3032C0.300592 14.611 0.626748 14.8014 0.980311 14.8014H15.0197C15.3732 14.8014 15.6994 14.611 15.8732 14.3032C16.0471 13.9953 16.0417 13.6177 15.8592 13.3149ZM8.00522 5.22616C8.40837 5.22616 8.7495 5.45359 8.7495 5.85672C8.7495 7.08681 8.60478 8.8545 8.60478 10.0846C8.60478 10.4051 8.25331 10.5394 8.00522 10.5394C7.67447 10.5394 7.39534 10.405 7.39534 10.0846C7.39534 8.8545 7.25065 7.08681 7.25065 5.85672C7.25065 5.45359 7.5814 5.22616 8.00522 5.22616ZM8.01556 12.8446C7.56075 12.8446 7.21959 12.4725 7.21959 12.0487C7.21959 11.6145 7.56072 11.2528 8.01556 11.2528C8.43937 11.2528 8.80118 11.6145 8.80118 12.0487C8.80118 12.4725 8.43937 12.8446 8.01556 12.8446Z" fill="#F7BF30"/>
</svg>  <span class="text-note">${message}</span></div>`
    snackBar.value = true
  }

  return {
    content,
    snackBar,
    color,
    location,
    timeout,
    SHOW_SUCCESS,
    SHOW_ERROR,
    SHOW_WARNING,
    SHOW_UNDO,
    SHOW_MESSAGE,
  }
})
